import { Button, CircularProgress, Modal, Paper } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import UserLookup from '../userLookup/UserLookup';


const Container = styled.div`

    display:flex;
    align-items:center;
    justify-content:center;

`;

const PaperContainer = styled.div`

    display:flex;
    padding-left:40px;
    height:600px;
    width:600px;
    align-items:space-around;
    justify-content:center;
    flex-direction:column;

`;

const BottomButtonsContainer = styled.div`

    display:flex;
    align-items:space-around;

`;

class Impersonate extends React.Component {

    constructor(props)
    {
        super(props);
        const {aboutCurrentUser = {}} = props;
        let userToImpersonate = null;
        if(aboutCurrentUser.IsImpersonating)
        {
            userToImpersonate = {name:`${aboutCurrentUser.lastName}, ${aboutCurrentUser.firstName}`, bun:aboutCurrentUser.bun}
        }
        this.state = {userToImpersonate};
    }

    render() {
        const {open = false,onImpersonate = ()=>{},loading, aboutCurrentUser= {}} = this.props;
     return(
            <Modal open={open} >
               <Container style={{height:window.innerHeight,width:window.innerWidth}}>
                        <Paper>
                            <PaperContainer>
                                <span className="paper-text">Impersonate User</span>

                                {!loading &&
                                    <React.Fragment>
                                        <UserLookup onUserSelected={userToImpersonate=>this.setState({userToImpersonate})} selectedUser={!!this.state.userToImpersonate ? {name:this.state.userToImpersonate.name,bun:this.state.userToImpersonate.bun} : null}/>
                                        <BottomButtonsContainer>
                                            <Button 
                                                variant="outlined" 
                                                color="primary" 
                                                className="attending-button-admin" 
                                                onClick={() => this.props.onCancel()} >
                                                Cancel
                                            </Button>
                                            <Button variant="outlined"
                                                    disabled={!this.state.userToImpersonate || this.state.userToImpersonate.bun === aboutCurrentUser.Bun}
                                                    color="primary" 
                                                    className="attending-button-admin" 
                                                    onClick={() => onImpersonate(this.state.userToImpersonate.bun)}  >
                                                Impersonate
                                            </Button>
                                            {aboutCurrentUser.isImpersonating &&
                                                <Button variant="outlined"
                                                        color="primary" 
                                                        className="attending-button-admin" 
                                                        onClick={() => onImpersonate(null)}  >
                                                    Unimpersonate
                                                </Button>
                                            }
                                        </BottomButtonsContainer>
                                    </React.Fragment>
                                }
                                {!!loading &&
                                    <CircularProgress/>
                                }
                                
                            </PaperContainer>
                        </Paper>
                </Container>       
            </Modal>
      )
    }
}

export default Impersonate;